import api from './api';

export default function trackEvent ({ event_name, ai_console_chat_id, instance, properties }) {
  const user_id = localStorage.getItem('username') || '';
  return api.buildRequest('ai-console-events', 'POST', {
    event_name,
    user_id,
    ai_console_chat_id: ai_console_chat_id || null,
    instance: instance || window.location.hostname,
    properties: properties || {}
  }).catch(err => console.error('[trackEvent] failed:', err));
}



//////////////////
// WEBPACK FOOTER
// ./utils/trackEvent.js
// module id = h45j
// module chunks = 1